(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usf-product-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class UsfProductDetails {
      constructor(root) {
        this.root = root;
        this.initGallery();
        this.initQty();
        this.initTabs();
        this.initCart();
        this.initVariants();
      }

      initVariants() {
        const wrap = this.root.querySelector('[data-pd-variants]');
        const json = this.root.querySelector('[data-pd-variant-json]');
        if (!wrap || !json) return;
        let variants;
        try { variants = JSON.parse(json.textContent); } catch (e) { return; }

        const buttons = Array.from(wrap.querySelectorAll('.usf-pd__variant-val'));
        const form = this.root.querySelector('form.usf-pd__form');
        const idInput = form && form.querySelector('input[name="id"]');
        const addBtn = form && form.querySelector('[type="submit"]');
        const addLabel = addBtn && addBtn.querySelector('span');
        const addText = addLabel ? addLabel.textContent.trim() : 'Add to Cart';
        const priceEl = this.root.querySelector('[data-pd-price]');
        const compareEl = this.root.querySelector('[data-pd-compare]');
        const skuEl = this.root.querySelector('[data-pd-sku]');
        const skuRow = this.root.querySelector('[data-pd-sku-row]');
        const mainImg = this.root.querySelector('[data-pd-main] img');

        const selected = () => {
          const out = [];
          buttons.forEach((b) => {
            if (b.classList.contains('is-active')) out[+b.dataset.optionIndex] = b.dataset.value;
          });
          return out;
        };

        // Grey out values that have no variant when combined with the other current selections.
        const markAvailability = (sel) => {
          buttons.forEach((b) => {
            const idx = +b.dataset.optionIndex;
            const exists = variants.some((v) =>
              v.options.every((o, i) => (i === idx ? o === b.dataset.value : o === sel[i]))
            );
            b.classList.toggle('is-unavailable', !exists);
          });
        };

        const apply = (variant) => {
          if (idInput) {
            idInput.value = variant ? variant.id : '';
            idInput.disabled = !variant || !variant.available;
          }
          if (addBtn) {
            const ok = variant && variant.available;
            addBtn.disabled = !ok;
            if (addLabel) addLabel.textContent = !variant ? 'Unavailable' : ok ? addText : 'Sold out';
          }
          if (!variant) return;
          if (priceEl) priceEl.textContent = variant.price;
          if (compareEl) {
            compareEl.hidden = !variant.compare;
            if (variant.compare) compareEl.textContent = variant.compare;
          }
          if (skuEl) skuEl.textContent = variant.sku || '';
          if (skuRow) skuRow.hidden = !variant.sku;
          if (mainImg && variant.image) {
            mainImg.src = variant.image;
            mainImg.removeAttribute('srcset');
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
          this.root.dispatchEvent(new CustomEvent('usf:variant-change', { bubbles: true, detail: { variant } }));
        };

        buttons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const idx = btn.dataset.optionIndex;
            buttons
              .filter((b) => b.dataset.optionIndex === idx)
              .forEach((b) => {
                const on = b === btn;
                b.classList.toggle('is-active', on);
                b.setAttribute('aria-checked', on ? 'true' : 'false');
              });
            const sel = selected();
            let variant = variants.find((v) => v.options.every((o, i) => o === sel[i]));
            // If the combination doesn't exist, jump to the closest variant that has the clicked value.
            if (!variant) {
              variant = variants.find((v) => v.options[+idx] === btn.dataset.value);
              if (variant) {
                buttons.forEach((b) => {
                  const on = variant.options[+b.dataset.optionIndex] === b.dataset.value;
                  b.classList.toggle('is-active', on);
                  b.setAttribute('aria-checked', on ? 'true' : 'false');
                });
              }
            }
            markAvailability(selected());
            apply(variant);
          });
        });

        markAvailability(selected());
      }

      initCart() {
        const form = this.root.querySelector('form.usf-pd__form');
        if (!form) return;
        const btn = form.querySelector('[type="submit"]');
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        form.addEventListener('submit', async (evt) => {
          evt.preventDefault();
          if (btn && btn.getAttribute('aria-disabled') === 'true') return;
          if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }

          try {
            const cartDrawer = document.querySelector('cart-drawer');
            const formData = new FormData(form);
            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
              const ids = cartDrawer.getSectionsToRender().map((s) => s.id);
              formData.append('sections', ids.join(','));
              formData.append('sections_url', window.location.pathname);
            }

            const res = await fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: formData,
            });
            const data = await res.json();

            if (data.status) {
              // Shopify returns { status, message, description } on error
              window.alert(data.description || data.message || 'Could not add to cart.');
              return;
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(data);
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
            } else {
              window.location = rootUrl + 'cart';
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } catch (e) {
            console.error('[usf-pd] add to cart failed', e);
            window.location = rootUrl + 'cart';
          } finally {
            if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); }
          }
        });
      }

      initGallery() {
        const main = this.root.querySelector('[data-pd-main] img');
        const thumbs = this.root.querySelectorAll('[data-pd-thumb]');
        if (!main || !thumbs.length) return;
        thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const src = thumb.getAttribute('data-media-src');
            if (src) {
              main.src = src;
              main.removeAttribute('srcset');
              main.alt = thumb.getAttribute('data-media-alt') || main.alt;
            }
            thumbs.forEach((t) => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          });
        });
      }

      initQty() {
        const input = this.root.querySelector('.usf-pd__qty-input');
        if (!input) return;
        this.root.querySelectorAll('[data-pd-qty]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const step = parseInt(btn.getAttribute('data-pd-qty'), 10);
            const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
            input.value = next;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      initTabs() {
        const wrap = this.root.querySelector('[data-pd-tabs]');
        if (!wrap) return;
        const tabs = wrap.querySelectorAll('[data-pd-tab]');
        const panels = wrap.querySelectorAll('[data-pd-panel]');
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const idx = tab.getAttribute('data-pd-tab');
            tabs.forEach((t) => {
              const on = t === tab;
              t.classList.toggle('is-active', on);
              t.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            panels.forEach((p) => {
              p.classList.toggle('is-hidden', p.getAttribute('data-pd-panel') !== idx);
            });
          });
        });
      }
    }

    function init() {
      document.querySelectorAll('.usf-pd').forEach((el) => {
        if (!el.dataset.usfPdInit) {
          el.dataset.usfPdInit = '1';
          new UsfProductDetails(el);
        }
      });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
